 
import { ConfigurationInterface, ConfigActions } from "../types/app-config";

const initialState: ConfigurationInterface = {
    name: "web",
    program: "",
    system_default: false,
    nav_menu: [],
    permission: {},
    menu_obj: {},
};

export function appConfig(
    state = initialState,
    action: ConfigActions
): ConfigurationInterface {
    switch (action.type) {
        case "SET_CONFIG":
            return action.data;
        default:
            return state;
    }
}
